import Store from 'lightningjs-redux';
import { getCurrentLayout } from '../../../logic/layout/layout.selectors';

const mapControllers = instance => [
  {
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.layout = value;
    },
  },
];

export default Store.control(mapControllers);
